
import { toRefs, reactive, onMounted, nextTick, computed, getCurrentInstance, watch, onActivated } from 'vue'
// import * as echarts from 'echarts'
// import { CountUp } from 'countup.js'
import { formatAxis } from '@/utils/formatTime'
import { useStore } from '@/store/index.ts'
import { topCardItemList, environmentList, activitiesList } from './mock'
export default {
  name: 'home',
  setup () {
    const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const state = reactive({
      topCardItemList,
      environmentList,
      activitiesList,
      tableData: {
        data: [
          {
            date: '2016-05-02',
            name: '1号实验室',
            address: '烟感2.1%OBS/M'
          },
          {
            date: '2016-05-04',
            name: '2号实验室',
            address: '温度30℃'
          },
          {
            date: '2016-05-01',
            name: '3号实验室',
            address: '湿度57%RH'
          }
        ]
      },
      myCharts: []
    })
    // 获取用户信息 vuex
    const getUserInfos = computed(() => {
      return store.state.userInfos.userInfos
    })
    // 当前时间提示语
    const currentTime = computed(() => {
      return formatAxis(new Date())
    })
    // 初始化数字滚动
    const initNumCountUp = () => {
      nextTick(() => {
        // new CountUp('titleNum1', Math.random() * 10000).start()
        // new CountUp('titleNum2', Math.random() * 10000).start()
        // new CountUp('titleNum3', Math.random() * 10000).start()
        // new CountUp('tipNum1', Math.random() * 1000).start()
        // new CountUp('tipNum2', Math.random() * 1000).start()
        // new CountUp('tipNum3', Math.random() * 1000).start()
      })
    }
    // 商品销售情
    const initHomeLaboratory = () => {
      // const myChart = echarts.init(proxy.$refs.homeLaboratoryRef)
      const option = {
        grid: {
          top: 50,
          right: 20,
          bottom: 30,
          left: 30
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['预购队列', '最新成交价'],
          right: 13
        },
        color: [
          '#63caff',
          '#49beff',
          '#03387a',
          '#03387a',
          '#03387a',
          '#6c93ee',
          '#a9abff',
          '#f7a23f',
          '#27bae7',
          '#ff6d9d',
          '#cb79ff',
          '#f95b5a',
          '#ccaf27',
          '#38b99c',
          '#93d0ff',
          '#bd74e0',
          '#fd77da',
          '#dea700'
        ],
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: [
          {
            type: 'value',
            name: '价格'
          }
        ],
        series: [
          {
            name: '预购队列',
            type: 'bar',
            data: [200, 85, 112, 275, 305, 415, 441, 405, 275, 305, 415, 441],
            itemStyle: {
              barBorderRadius: [4, 4, 0, 0],
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: 'linear',
                global: false,
                colorStops: [
                  {
                    offset: 0,
                    color: '#0b9eff'
                  },
                  {
                    offset: 1,
                    color: '#63caff'
                  }
                ]
              }
            }
          },
          {
            name: '最新成交价',
            type: 'line',
            data: [50, 85, 22, 155, 170, 25, 224, 245, 285, 300, 415, 641],
            itemStyle: {
              color: '#febb50'
            }
          }
        ]
      }
    //   myChart.setOption(option)
    //   state.myCharts.push(myChart)
    }
    // 履约超时预警
    const initHomeOvertime = () => {
      // const myChart = echarts.init(proxy.$refs.homeOvertimeRef)
      const option = {
        grid: {
          top: 50,
          right: 20,
          bottom: 30,
          left: 30
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单数量', '超时数量', '在线数量', '预警数量'],
          right: 13
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: [
          {
            type: 'value',
            name: '数量'
          }
        ],
        series: [
          {
            name: '订单数量',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20, 11, 13, 10, 9, 17, 19]
          },
          {
            name: '超时数量',
            type: 'bar',
            data: [15, 12, 26, 15, 11, 16, 31, 13, 5, 16, 13, 15]
          },
          {
            name: '在线数量',
            type: 'line',
            data: [15, 20, 16, 20, 30, 8, 16, 19, 12, 18, 19, 14]
          },
          {
            name: '预警数量',
            type: 'line',
            data: [10, 10, 13, 12, 15, 18, 19, 10, 12, 15, 11, 17]
          }
        ]
      }
      // myChart.setOption(option)
      // state.myCharts.push(myChart)
    }
    // 批量设置 echarts resize
    const initEchartsResizeFun = () => {
      nextTick(() => {
        for (let i = 0; i < state.myCharts.length; i++) {
        //   state.myCharts[i].resize()
        }
      })
    }
    // 批量设置 echarts resize
    const initEchartsResize = () => {
      window.addEventListener('resize', initEchartsResizeFun)
    }
    // 页面加载时
    onMounted(() => {
      initNumCountUp()
      initHomeLaboratory()
      initHomeOvertime()
      initEchartsResize()
    })
    // 由于页面缓存原因，keep-alive
    onActivated(() => {
      initEchartsResizeFun()
    })
    // 监听 vuex 中的 tagsview 开启全屏变化，重新 resize 图表，防止不出现/大小不变等
    watch(
      () => store.state.tagsViewRoutes.isTagsViewCurrenFull,
      () => {
        initEchartsResizeFun()
      }
    )
    return {
      getUserInfos,
      currentTime,
      ...toRefs(state)
    }
  }
}
